import { useMemo } from 'react';

import { useCurrentUser } from '@bonusly/who-am-i';

import { Bonus } from '../../../../../../types/bonus';
import { Reaction } from '../lib/reaction';

export const useSelectedReaction = (bonus: Bonus) => {
	const user = useCurrentUser();

	return useMemo(() => {
		const bonusReaction = bonus.reactions?.find((reaction) => reaction.user_id === user.id);

		if (!bonusReaction) {
			return undefined;
		}

		return Reaction.fromRecord(bonusReaction._id, bonusReaction.emoji);
	}, [bonus, user]);
};
